import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const getAnimals = () => api.get("/animals").then((r) => r.data);
export const getAnimal = (id) => api.get(`/animals/${id}`).then((r) => r.data);
export const getStories = () => api.get("/stories").then((r) => r.data);
export const getStory = (id) => api.get(`/stories/${id}`).then((r) => r.data);
export const getStats = () => api.get("/stats").then((r) => r.data);
export const getRecentDonations = (limit = 20) =>
  api.get(`/donations/recent?limit=${limit}`).then((r) => r.data);
export const createDonationOrder = (data) =>
  api.post("/donations/create-order", data).then((r) => r.data);
export const verifyDonation = (data) =>
  api.post("/donations/verify", data).then((r) => r.data);
export const submitVolunteer = (data) =>
  api.post("/volunteers", data).then((r) => r.data);
export const submitContact = (data) =>
  api.post("/contact", data).then((r) => r.data);
export const subscribeNewsletter = (email) =>
  api.post("/newsletter", { email }).then((r) => r.data);
export const getCampaignStats = (slug) =>
  api.get(`/campaigns/${slug}/stats`).then((r) => r.data);
export const getCampaignTopDonors = (slug, limit = 5) =>
  api.get(`/campaigns/${slug}/top-donors?limit=${limit}`).then((r) => r.data);
